export default __webpack_public_path__ + "static/media/background_4_large.80f75624.jpg";